import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetching = (state: IStore) => state.infoOrganizer.isFetching;
const getIsFetchFailed = (state: IStore) => state.infoOrganizer.isFetchFailed;
const getOrganizerContent = (state: IStore) => state.infoOrganizer.content;

export {
  getIsFetching,
  getIsFetchFailed,
  getOrganizerContent,
};


// WEBPACK FOOTER //
// ./src/pages/InfoOrganizerPage/Redux/selectors.tsx